import {
  ChevronLeft,
  FileBadge2,
  FileSignature,
  FolderArchive,
  Handshake,
  HardHat,
  LayoutDashboard,
  Settings,
  ShieldCheck,
  Target,
  Truck,
  UserRoundCheck,
  Users,
  WalletCards,
  Calculator,
  X
} from "lucide-react";
import { BrandLogo } from "./BrandLogo";
import { financialSections } from "./FinancialNavigation";

export const menu = [
  { id: "dashboard", label: "Visão Geral", icon: LayoutDashboard },
  { id: "novo-negocio", label: "Novo Contrato", icon: Handshake },
  { id: "clientes", label: "Clientes", icon: Users },
  { id: "contratos", label: "Contratos", icon: FileSignature },
  { id: "obras", label: "Obras", icon: HardHat },
  { id: "financeiro", label: "Financeiro", icon: WalletCards },
  { id: "notas-fiscais", label: "Notas Fiscais", icon: FileBadge2 },
  { id: "compromissos-terceiros", label: "Compromissos de Terceiros", icon: ShieldCheck },
  { id: "centros", label: "Centros de Resultado", icon: Target },
  { id: "fornecedores", label: "Fornecedores", icon: Truck },
  { id: "corretores", label: "Corretores", icon: UserRoundCheck },
  { id: "documentos", label: "Documentos", icon: FolderArchive },
  { id: "configuracoes", label: "Configurações", icon: Settings }
];

export function Sidebar({
  route,
  open,
  collapsed,
  onNavigate,
  onClose,
  onToggle
}: {
  route: string;
  open: boolean;
  collapsed: boolean;
  onNavigate: (id: string) => void;
  onClose: () => void;
  onToggle: () => void;
}) {
  return <>
    {open && <button className="sidebar-overlay" onClick={onClose} aria-label="Fechar menu"/>}
    <aside className={`sidebar ${open ? "sidebar-open" : ""} ${collapsed ? "sidebar-collapsed" : ""}`}>
      <div className="brand">
        <BrandLogo variant={collapsed ? "symbol" : "horizontal"} className={collapsed ? "sidebar-symbol" : "sidebar-logo"}/>
        <button className="mobile-close" onClick={onClose} aria-label="Fechar menu"><X size={20}/></button>
      </div>
      <div className="company-tag">Compromisso que se constrói</div>
      <nav aria-label="Menu principal">
        {menu.map((item) => <div className={["financeiro", "obras"].includes(item.id) ? "sidebar-financial-group" : undefined} key={item.id}>
          <button
            className={route === item.id || route.startsWith(`${item.id}/`) ? "active" : ""}
            onClick={() => onNavigate(item.id === "financeiro" ? "financeiro/visao-geral" : item.id)}
            title={collapsed ? item.label : undefined}
          ><item.icon size={18}/><span>{item.label}</span></button>
          {item.id === "financeiro" && !collapsed && route.startsWith("financeiro") && <div className="sidebar-financial-submenu">
            {financialSections.map((section) => <button
              key={section.id}
              className={route === section.id ? "active" : ""}
              onClick={() => onNavigate(section.id)}
            ><section.icon size={15}/><span>{section.label}</span></button>)}
          </div>}
          {item.id === "obras" && !collapsed && route.startsWith("obras") && <div className="sidebar-financial-submenu">
            <button className={route === "obras/orcamento" ? "active" : ""} onClick={() => onNavigate("obras/orcamento")}><Calculator size={15}/><span>Orçamento</span></button>
          </div>}
        </div>)}
      </nav>
      <div className="sidebar-footer">
        <div className="sidebar-version"><BrandLogo variant="symbol"/><span>CCE Gestão · v{__APP_VERSION__}</span></div>
        <button className="collapse-button" onClick={onToggle} aria-label={collapsed ? "Expandir menu" : "Recolher menu"}><ChevronLeft size={17}/><span>Recolher menu</span></button>
      </div>
    </aside>
  </>;
}
